/**
 * Адресация диалога: инбокс и хранилище пишут id по-разному.
 *
 * Список инбокса помечает канал префиксом (`tg:12345`, `w:session-1`), а API
 * карточки и хранилище знают сырой id. Разбор жил в двух местах разом —
 * `DialogueWorkspace` и `InboxPage`, — и третьей копии быть не должно:
 * разъедутся, и получатся две карточки на один диалог.
 */

export type InboxChannel = 'email' | 'telegram' | 'widget';

export interface ConversationSource {
  readonly sourceType: InboxChannel;
  /** Сырой id: threadId / chatId / sessionId */
  readonly sourceId: string;
}

/** Разбирает id из списка инбокса в пару (канал, сырой id). */
export function inboxIdToSource(item: { id: string; channel: InboxChannel }): ConversationSource {
  if (item.channel === 'telegram') {
    return { sourceType: 'telegram', sourceId: item.id.replace(/^tg:/, '') };
  }
  if (item.channel === 'widget') {
    return { sourceType: 'widget', sourceId: item.id.replace(/^w:/, '') };
  }
  return { sourceType: 'email', sourceId: item.id };
}
